<template>
  <div class="page" :id="item.path">
    <TitleSection 
      :title="item.title"
      :subtitle="item.subtitle"
      :paragraphs="item.paragraphs"
      :paragraph="item.paragraph"
      :important="item.important"
      :hyperlink="item.hyperlink"
      :topic_path="item.path"
    />
    <PicturesSection v-if="item.image" :imagedata="item.image"/>
    <RequestView v-if="item.request" :request="item.request"/>
    <ParameterTable v-if="item.headersPayload" :items="item.headersPayload" text="Header Parameter"/>
    <ParameterTable v-if="item.pathPayload" :items="item.pathPayload" text="Path Parameter"/>
    <div v-if="item.request.payloads">
      <CodeSampleView
        v-for="(payload, index) in item.request.payloads"
        :key="index"
        :code="payload.content"
        :text="payload.title"
        :openPanel="[1]"
      />
    </div>
    <CodeSampleView
      v-else-if="item.request.payload"
      :code="item.request.payload"
      text="Request payload sample"
      :openPanel="[1]"
    />

    <ParameterTable v-if="item.parameterPayload" :items="item.parameterPayload" :notes="item.footerNotes" text="Body Parameters"/>
    <DomainTable v-if="item.domainsProperties" :items="item.domainsProperties" text="Domain" />
    <CodeSampleView v-if="item.request.responses" :openPanel="[0]" :code="item.request.responses" text="Response sample"/>
    <ParameterTable v-if="item.queryPayload" :items="item.queryPayload" text="Query Parameter"/>
    <Troubleshooter v-if="item.troubleshooting" :itemsdata="item.troubleshooting"/>
  </div>
</template>


<script>
import TitleSection from './TitleSection'
import ParameterTable from './ParameterTable.vue'
import PicturesSection from './PicturesSection'
import DomainTable from './DomainTable.vue'
import RequestView from './RequestView'
import CodeSampleView from './CodeSampleView.vue'
import Troubleshooter from "./Troubleshooter"

export default {
  name: 'DocSection',
  props: {
    item: {
      type: Object
    },
  },
  components: {
    TitleSection,
    RequestView,
    ParameterTable,
    PicturesSection,
    DomainTable,
    CodeSampleView,
    Troubleshooter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documentation/DocSection.vue